import { useTranslation } from 'react-i18next';

import { Button } from '@components/ui/Button';

import type { AccountInfo } from '../../types/auth.types';

interface AccountSelectorProps {
  accounts: AccountInfo[];
  onSelect: (account: AccountInfo) => void;
}

export function AccountSelector({ accounts, onSelect }: AccountSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-[2rem] font-semibold leading-tight text-foreground">
          {t('auth.selectAccount')}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('auth.selectAccountSubtitle')}</p>
      </div>

      <div className="space-y-3">
        {accounts.map((account) => (
          <button
            key={account.accountId}
            type="button"
            onClick={() => onSelect(account)}
            className="w-full rounded-lg border border-border bg-surface px-4 py-3.5 text-left transition-colors hover:border-primary hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <span className="block text-sm font-medium text-foreground">{account.businessName}</span>
            {account.roles.length > 0 && (
              <span className="mt-0.5 block text-xs text-muted-foreground">
                {account.roles.join(', ')}
              </span>
            )}
          </button>
        ))}
      </div>

      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="w-full justify-center text-muted-foreground"
        onClick={() => window.location.reload()}
      >
        {t('auth.backToLogin')}
      </Button>
    </div>
  );
}
